(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-spatula-bundle"] && !Shopify.designMode) return;
  try {
    
  class BlackFridayBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.spatulaQuantities = new Map();
      this.addonQuantities = new Map();
      this.maxTrios = Number(this.dataset.maxTrios) || 3;
      this.loading = false;
      this.spatulaCards = Array.from(this.querySelectorAll('[data-spatula-card]'));
      this.addonCards = Array.from(this.querySelectorAll('[data-addon-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.countElement = this.querySelector('[data-spatula-count]');
      this.capacityElement = this.querySelector('[data-spatula-capacity]');
      this.addonCountElement = this.querySelector('[data-addon-count]');
      this.addonCapacityElement = this.querySelector('[data-addon-capacity]');
      this.progressElement = this.querySelector('[data-progress]');
      this.slotsElement = this.querySelector('[data-slots]');
      this.regularValueElement = this.querySelector('[data-regular-value]');
      this.savingsElement = this.querySelector('[data-savings]');
      this.bundlePriceElement = this.querySelector('[data-bundle-price]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-status]');
      this.successElement = this.querySelector('[data-bundle-success]');
      this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      this.addEventListener('click', (event) => this.handleClick(event));
      this.update();
    }

    get spatulaCount() {
      return Array.from(this.spatulaQuantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    get addonCount() {
      return Array.from(this.addonQuantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    get completedTrios() {
      return Math.floor(this.spatulaCount / 3);
    }

    handleClick(event) {
      const spatulaIncrease = event.target.closest('[data-spatula-increase]');
      const spatulaDecrease = event.target.closest('[data-spatula-decrease]');
      const addonIncrease = event.target.closest('[data-addon-increase]');
      const addonDecrease = event.target.closest('[data-addon-decrease]');
      const filter = event.target.closest('[data-filter]');
      if (spatulaIncrease) this.changeSpatula(spatulaIncrease.closest('[data-spatula-card]'), 1);
      if (spatulaDecrease) this.changeSpatula(spatulaDecrease.closest('[data-spatula-card]'), -1);
      if (addonIncrease) this.changeAddon(addonIncrease.closest('[data-addon-card]'), 1);
      if (addonDecrease) this.changeAddon(addonDecrease.closest('[data-addon-card]'), -1);
      if (filter) this.setFilter(filter);
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
      if (event.target.closest('[data-build-another]')) this.buildAnother();
    }

    setFilter(filter) {
      const value = filter.dataset.filter;
      this.filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      this.spatulaCards.forEach((card) => {
        card.hidden = value !== 'all' && card.dataset.kind !== value;
      });
    }

    changeSpatula(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.spatulaQuantities.get(variantId) || 0;
      const next = current + change;
      if (next < 0) return;
      if (change > 0 && this.spatulaCount >= this.maxTrios * 3) {
        this.setStatus(this.dataset.fullMessage);
        return;
      }
      const addonsAdjusted = change < 0
        ? this.trimAddonsToCapacity(Math.floor((this.spatulaCount - 1) / 3))
        : false;
      if (next === 0) this.spatulaQuantities.delete(variantId);
      else this.spatulaQuantities.set(variantId, next);
      this.setStatus(addonsAdjusted ? this.dataset.removeAddonMessage : '');
      this.update();
    }

    trimAddonsToCapacity(capacity) {
      let excess = this.addonCount - capacity;
      if (excess <= 0) return false;

      const entries = Array.from(this.addonQuantities.entries()).reverse();
      entries.forEach(([variantId, quantity]) => {
        if (excess <= 0) return;
        const removeQuantity = Math.min(quantity, excess);
        const nextQuantity = quantity - removeQuantity;
        if (nextQuantity === 0) this.addonQuantities.delete(variantId);
        else this.addonQuantities.set(variantId, nextQuantity);
        excess -= removeQuantity;
      });

      return true;
    }

    changeAddon(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.addonQuantities.get(variantId) || 0;
      const next = current + change;
      if (next < 0) return;
      if (change > 0 && this.addonCount >= this.completedTrios) {
        this.setStatus(this.dataset.addonLimitMessage);
        return;
      }
      if (next === 0) this.addonQuantities.delete(variantId);
      else this.addonQuantities.set(variantId, next);
      this.setStatus('');
      this.update();
    }

    selectedItems(cards, quantities) {
      const selected = [];
      cards.forEach((card) => {
        const quantity = quantities.get(card.dataset.variantId) || 0;
        if (!quantity) return;
        selected.push({
          id: Number(card.dataset.variantId),
          quantity,
          price: Number(card.dataset.price),
          title: card.dataset.title,
          image: card.dataset.image
        });
      });
      return selected;
    }

    update() {
      const spatulas = this.selectedItems(this.spatulaCards, this.spatulaQuantities);
      const addons = this.selectedItems(this.addonCards, this.addonQuantities);
      const maxSpatulas = this.maxTrios * 3;
      const completedTrios = this.completedTrios;
      this.countElement.textContent = String(this.spatulaCount);
      this.capacityElement.textContent = String(maxSpatulas);
      this.addonCountElement.textContent = String(this.addonCount);
      this.addonCapacityElement.textContent = String(completedTrios);

      this.spatulaCards.forEach((card) => this.updateCard(card, this.spatulaQuantities, this.spatulaCount >= maxSpatulas));
      this.addonCards.forEach((card) => this.updateCard(card, this.addonQuantities, this.addonCount >= completedTrios));
      this.renderSlots(spatulas, maxSpatulas);

      const unitPrices = [];
      spatulas.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) unitPrices.push(item.price);
      });
      unitPrices.sort((a, b) => a - b);
      const spatulaSavings = unitPrices.slice(0, completedTrios).reduce((total, price) => total + price, 0);
      const addonValue = addons.reduce((total, item) => total + item.price * item.quantity, 0);
      const addonSavings = addons.reduce((total, item) => total + Math.floor(item.price * 0.5) * item.quantity, 0);
      const spatulaValue = unitPrices.reduce((total, price) => total + price, 0);
      const regularValue = spatulaValue + addonValue;
      const savings = spatulaSavings + addonSavings;
      const estimatedPrice = regularValue - savings;
      const ready = this.spatulaCount >= 3 && this.spatulaCount % 3 === 0;

      this.regularValueElement.textContent = this.spatulaCount ? this.formatMoney(regularValue) : '—';
      this.savingsElement.textContent = ready ? this.formatMoney(savings) : '—';
      this.bundlePriceElement.textContent = ready ? this.formatMoney(estimatedPrice) : '—';
      this.progressElement.textContent = this.progressMessage(completedTrios);
      this.addButton.disabled = !ready || this.loading;
      if (this.loading) this.addButton.textContent = this.dataset.loadingText || 'Adding your Black Friday bundle…';
      else if (ready) this.addButton.textContent = `Add ${completedTrios} bundle${completedTrios === 1 ? '' : 's'} — ${this.formatMoney(estimatedPrice)}`;
      else {
        const nextTarget = Math.min((completedTrios + 1) * 3, maxSpatulas);
        const remaining = Math.max(nextTarget - this.spatulaCount, 0);
        this.addButton.textContent = `Choose ${remaining} more spatula${remaining === 1 ? '' : 's'}`;
      }
    }

    updateCard(card, quantities, limitReached) {
      const quantity = quantities.get(card.dataset.variantId) || 0;
      card.dataset.selected = String(quantity > 0);
      const quantityElement = card.querySelector('[data-quantity]');
      const increase = card.querySelector('[data-spatula-increase], [data-addon-increase]');
      const decrease = card.querySelector('[data-spatula-decrease], [data-addon-decrease]');
      if (quantityElement) quantityElement.textContent = String(quantity);
      if (increase) increase.disabled = limitReached;
      if (decrease) decrease.disabled = quantity === 0;
    }

    renderSlots(spatulas, capacity) {
      const selected = [];
      spatulas.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) selected.push(item);
      });
      const slots = [];
      for (let index = 0; index < capacity; index += 1) {
        const slot = document.createElement('div');
        const item = selected[index];
        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          slot.appendChild(image);
        } else {
          const label = document.createElement('span');
          label.textContent = String(index + 1);
          slot.appendChild(label);
        }
        slots.push(slot);
      }
      this.slotsElement.replaceChildren(...slots);
    }

    progressMessage(completedTrios) {
      if (!this.spatulaCount) return this.dataset.progressEmptyText;
      if (this.spatulaCount % 3 === 0) {
        return `${completedTrios} free spatula${completedTrios === 1 ? '' : 's'} unlocked. You may add ${completedTrios} half-price extra${completedTrios === 1 ? '' : 's'}.`;
      }
      const remaining = 3 - (this.spatulaCount % 3);
      return `Choose ${remaining} more spatula${remaining === 1 ? '' : 's'} to unlock another free Pat.`;
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message || '';
    }

    buildAnother() {
      if (this.successElement) this.successElement.hidden = true;
      this.querySelector('[data-spatula-card]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async addBundle() {
      if (this.loading || this.spatulaCount < 3 || this.spatulaCount % 3 !== 0) return;
      this.loading = true;
      if (this.successElement) this.successElement.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const bundleId = globalThis.crypto?.randomUUID?.() || `pat-black-friday-${Date.now()}`;
        const spatulas = this.selectedItems(this.spatulaCards, this.spatulaQuantities).map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'black-friday',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'spatula'
          }
        }));
        const addons = this.selectedItems(this.addonCards, this.addonQuantities).map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'black-friday',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'addon'
          }
        }));
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [...spatulas, ...addons] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.errorMessage);
        this.loading = false;
        this.spatulaQuantities.clear();
        this.addonQuantities.clear();
        this.setStatus('');
        this.update();
        if (this.successElement) {
          this.successElement.hidden = false;
          this.successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || this.dataset.errorMessage);
        this.update();
      }
    }
  }

  if (!customElements.get('black-friday-bundle')) {
    customElements.define('black-friday-bundle', BlackFridayBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-gift-set"] && !Shopify.designMode) return;
  try {
    
  class HappyGiftSet extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.mode = null;
      this.quantities = new Map();
      this.sponge = null;
      this.loading = false;
      this.dialogShownForCompleteSelection = false;
      this.showingAll = false;
      this.customCards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.presetCards = Array.from(this.querySelectorAll('[data-preset-product]'));
      this.spongeOptions = Array.from(this.querySelectorAll('[data-sponge-option]'));
      this.customPanel = this.querySelector('[data-custom-panel]');
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.dialog = this.querySelector('[data-sponge-dialog]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-status]');
      this.successElement = this.querySelector('[data-success]');
      this.selectedProductsElement = this.querySelector('[data-selected-products]');
      this.regularValueElement = this.querySelector('[data-regular-value]');
      this.savingsElement = this.querySelector('[data-savings]');
      this.bundlePriceElement = this.querySelector('[data-bundle-price]');
      this.countElement = this.querySelector('[data-selected-count]');
      this.stickyCountElement = this.querySelector('[data-sticky-count]');
      this.stickyPriceElement = this.querySelector('[data-sticky-price]');
      this.stickySavingsElement = this.querySelector('[data-sticky-savings]');
      this.nextButton = this.querySelector('[data-next-action]');
      this.toggleAllButton = this.querySelector('[data-toggle-all]');
      this.copy = {
        chooseThree: this.dataset.copyChooseThree,
        chooseTwo: this.dataset.copyChooseTwo,
        chooseOne: this.dataset.copyChooseOne,
        chooseSponge: this.dataset.copyChooseSponge,
        add: this.dataset.copyAdd,
        adding: this.dataset.copyAdding,
        trioFull: this.dataset.copyTrioFull,
        error: this.dataset.copyError,
        seeAll: this.dataset.copySeeAll,
        showLess: this.dataset.copyShowLess
      };
      this.currency = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });

      this.addEventListener('click', (event) => this.handleClick(event));
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeDialog();
      });
      this.update();
    }

    get selectedCount() {
      if (this.mode === 'preset') return this.presetCards.length;
      return Array.from(this.quantities.values()).reduce((sum, quantity) => sum + quantity, 0);
    }

    handleClick(event) {
      const increase = event.target.closest('[data-increase]');
      const decrease = event.target.closest('[data-decrease]');
      const sponge = event.target.closest('[data-sponge-option]');

      if (event.target.closest('[data-start-preset]')) this.startPreset();
      if (event.target.closest('[data-build-own]')) this.openCustomBuilder();
      if (increase) this.changeQuantity(increase.closest('[data-product-card]'), 1);
      if (decrease) this.changeQuantity(decrease.closest('[data-product-card]'), -1);
      if (sponge) this.selectSponge(sponge);
      if (event.target.closest('[data-toggle-all]')) this.toggleAllProducts();
      if (event.target.closest('[data-next-action]')) this.handleNextAction();
      if (event.target.closest('[data-close-dialog]')) this.closeDialog();
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
    }

    startPreset() {
      if (this.presetCards.length !== 3) return;
      this.mode = 'preset';
      this.quantities.clear();
      this.sponge = null;
      this.resetSpongeOptions();
      this.openDialog();
      this.update();
    }

    openCustomBuilder() {
      this.mode = 'custom';
      this.sponge = null;
      this.resetSpongeOptions();
      this.customPanel.hidden = false;
      this.stickyBar.hidden = false;
      this.dataset.customOpen = 'true';
      this.customPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.update();
    }

    toggleAllProducts() {
      this.showingAll = !this.showingAll;
      this.querySelectorAll('[data-additional]').forEach((card) => {
        card.hidden = !this.showingAll;
      });
      this.toggleAllButton.setAttribute('aria-expanded', String(this.showingAll));
      this.toggleAllButton.textContent = this.showingAll ? this.copy.showLess : this.copy.seeAll;
    }

    changeQuantity(card, delta) {
      if (!card) return;
      this.mode = 'custom';
      const id = card.dataset.variantId;
      const current = this.quantities.get(id) || 0;
      const next = current + delta;
      if (next < 0) return;
      if (delta > 0 && this.selectedCount >= 3) {
        this.setStatus(this.copy.trioFull);
        return;
      }
      if (next === 0) this.quantities.delete(id);
      else this.quantities.set(id, next);
      if (this.selectedCount < 3) {
        this.dialogShownForCompleteSelection = false;
        this.sponge = null;
        this.resetSpongeOptions();
      }
      this.setStatus('');
      this.update();
      if (this.selectedCount === 3 && !this.dialogShownForCompleteSelection) {
        this.dialogShownForCompleteSelection = true;
        this.openDialog();
      }
    }

    handleNextAction() {
      if (this.selectedCount === 3) this.openDialog();
      else this.customPanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    openDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) this.dialog.showModal();
    }

    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
    }

    selectSponge(option) {
      this.sponge = {
        id: Number(option.dataset.variantId),
        price: Number(option.dataset.price),
        title: option.dataset.title
      };
      this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      this.setStatus('');
      this.update();
    }

    resetSpongeOptions() {
      this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', 'false'));
    }

    selectedItems() {
      const source = this.mode === 'preset' ? this.presetCards : this.customCards;
      return source.flatMap((card) => {
        const quantity = this.mode === 'preset' ? 1 : (this.quantities.get(card.dataset.variantId) || 0);
        if (!quantity) return [];
        return [{
          id: Number(card.dataset.variantId),
          quantity,
          price: Number(card.dataset.price),
          kind: card.dataset.kind,
          discountRate: Number(card.dataset.discountRate),
          sku: card.dataset.sku,
          title: card.dataset.title,
          image: card.dataset.image
        }];
      });
    }

    totals() {
      const selected = this.selectedItems();
      const productValue = selected.reduce((total, item) => total + item.price * item.quantity, 0);
      const productSavings = selected.reduce((total, item) => {
        const discount = Math.floor(item.price * (item.discountRate / 100));
        return total + discount * item.quantity;
      }, 0);
      return {
        productValue,
        productSavings,
        regularValue: productValue + (this.sponge ? this.sponge.price : 0),
        bundlePrice: productValue - productSavings,
        savings: productSavings + (this.sponge ? this.sponge.price : 0)
      };
    }

    update() {
      const count = this.selectedCount;
      const selected = this.selectedItems();
      const totals = this.totals();
      if (this.countElement) this.countElement.textContent = String(count);
      if (this.stickyCountElement) this.stickyCountElement.textContent = String(count);

      this.customCards.forEach((card) => {
        const quantity = this.quantities.get(card.dataset.variantId) || 0;
        card.dataset.selected = String(quantity > 0);
        const quantityElement = card.querySelector('[data-quantity]');
        const increase = card.querySelector('[data-increase]');
        const decrease = card.querySelector('[data-decrease]');
        if (quantityElement) quantityElement.textContent = String(quantity);
        if (increase) increase.disabled = count >= 3;
        if (decrease) decrease.disabled = quantity === 0;
      });

      if (this.stickyPriceElement) this.stickyPriceElement.textContent = count ? this.formatMoney(totals.bundlePrice) : '—';
      if (this.stickySavingsElement) this.stickySavingsElement.textContent = count ? this.formatMoney(totals.productSavings) : '—';

      if (this.nextButton) {
        if (count === 0) this.nextButton.textContent = this.copy.chooseThree;
        else if (count === 1) this.nextButton.textContent = this.copy.chooseTwo;
        else if (count === 2) this.nextButton.textContent = this.copy.chooseOne;
        else this.nextButton.textContent = this.copy.chooseSponge;
      }

      if (this.selectedProductsElement) {
        this.selectedProductsElement.replaceChildren();
        selected.forEach((item) => {
          const chip = document.createElement('span');
          chip.textContent = item.quantity > 1 ? `${item.title} × ${item.quantity}` : item.title;
          this.selectedProductsElement.appendChild(chip);
        });
      }

      const complete = count === 3;
      this.regularValueElement.textContent = complete && this.sponge ? this.formatMoney(totals.regularValue) : '—';
      this.savingsElement.textContent = complete ? this.formatMoney(totals.savings) : '—';
      this.bundlePriceElement.textContent = complete ? this.formatMoney(totals.bundlePrice) : '—';

      const ready = complete && Boolean(this.sponge);
      this.addButton.disabled = !ready || this.loading;
      if (this.loading) this.addButton.textContent = this.copy.adding;
      else if (ready) this.addButton.textContent = `${this.copy.add} — ${this.formatMoney(totals.bundlePrice)}`;
      else this.addButton.textContent = this.copy.chooseSponge;
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message;
    }

    async addBundle() {
      if (this.loading || this.selectedCount !== 3 || !this.sponge) return;
      this.loading = true;
      if (this.successElement) this.successElement.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const bundleId = globalThis.crypto?.randomUUID?.() || `happy-gift-${Date.now()}`;
        const items = this.selectedItems().map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'trio',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'pat',
            _pat_bundle_class: item.kind,
            _pat_bundle_item: 'pat-standard'
          }
        }));
        items.push({
          id: this.sponge.id,
          quantity: 1,
          properties: {
            _pat_bundle: 'trio',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'sponge',
            _pat_bundle_class: 'sponge',
            _pat_bundle_item: 'sponge'
          }
        });

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.copy.error);

        const cartResponse = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        const cart = await cartResponse.json();
        const addedQuantity = cart.items
          .filter((item) => item.properties?._pat_bundle_id === bundleId)
          .reduce((total, item) => total + item.quantity, 0);
        if (!cartResponse.ok || addedQuantity !== 4) throw new Error(this.copy.error);

        this.loading = false;
        this.closeDialog();
        this.quantities.clear();
        this.sponge = null;
        this.mode = null;
        this.dialogShownForCompleteSelection = false;
        this.resetSpongeOptions();
        this.stickyBar.hidden = true;
        delete this.dataset.customOpen;
        this.setStatus('');
        this.update();
        document.dispatchEvent(new CustomEvent('update-cart'));
        if (this.successElement) {
          this.successElement.hidden = false;
          window.setTimeout(() => { this.successElement.hidden = true; }, 8000);
        }
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || this.copy.error);
        this.update();
      }
    }
  }

  if (!customElements.get('happy-gift-set')) {
    customElements.define('happy-gift-set', HappyGiftSet);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pat-four-pack-add]');
    if (!button || button.closest('#pat-drawer-offer')) return;
    const offer = button.closest('[data-pat-four-pack-extra]');
    if (!offer || offer.dataset.busy === 'true') return;
    const controls = offer.querySelectorAll('button');
    const status = offer.querySelector('[data-pat-four-pack-status]');
    const root = window.Shopify?.routes?.root || '/';
    const request = async (path, body) => {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };
    offer.dataset.busy = 'true';
    controls.forEach(control => { control.disabled = true; });
    status.textContent = offer.dataset.busyLabel || '';
    try {
      const cartForm = button.closest('form');
      const quantities = [...cartForm.querySelectorAll('[name="updates[]"]')].map(input => Number(input.value));
      if (quantities.some(value => !Number.isInteger(value) || value < 0)) throw new Error('Invalid quantity');
      let cart = await request('cart/update.js', { updates: quantities });
      const hasFourPack = cart.items.some(item => item.handle === 'sudsy-pat-4-pack' || item.handle === 'sudsy-pat-sponge-bundles');
      const hasFourPackExtra = cart.items.some(item => item.properties?._pat_cart_addon === 'four-pack-extra');
      if (cart.currency !== 'USD' || cart.total_price >= 5000 || !hasFourPack || hasFourPackExtra) {
        window.location.assign(root + 'cart');
        return;
      }
      await request('cart/add.js', {
        items: [{
          id: Number(button.dataset.patFourPackAdd),
          quantity: 1,
          properties: { _pat_cart_addon: 'four-pack-extra' }
        }]
      });
      cart = await request('cart.js');
      const selected = cart.items.find(item =>
        item.properties?._pat_cart_addon === 'four-pack-extra' &&
        Number(item.variant_id) === Number(button.dataset.patFourPackAdd)
      );
      if (!selected) throw new Error('Add-on unavailable');
      window.location.assign(root + 'cart');
    } catch (error) {
      status.textContent = offer.dataset.error || '';
      offer.dataset.busy = 'false';
      controls.forEach(control => { control.disabled = false; });
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pat-wooden-add]');
    if (!button || button.closest('#pat-drawer-offer')) return;
    const offer = button.closest('[data-pat-wooden-offer]');
    if (offer.dataset.busy === 'true') return;
    const controls = offer.querySelectorAll('button');
    const status = offer.querySelector('[data-pat-wooden-status]');
    const root = window.Shopify?.routes?.root || '/';
    const request = async (path, body) => {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };
    offer.dataset.busy = 'true';
    controls.forEach(control => { control.disabled = true; });
    status.textContent = offer.dataset.busyLabel || '';
    let added = false;
    try {
      const cartForm = button.closest('form');
      const quantities = [...cartForm.querySelectorAll('[name="updates[]"]')].map(input => Number(input.value));
      if (quantities.some(value => !Number.isInteger(value) || value < 0)) throw new Error('Invalid quantity');
      let cart = await request('cart/update.js', { updates: quantities });
      const bundleDiscounts = ['Silly Pat trio — 20% off', 'Wooden Pat trio — 20% off', 'Free Sudsy Pat sponge'];
      const discountsAllowed = !(cart.cart_level_discount_applications || []).length && cart.items.every(item =>
        (item.line_level_discount_allocations || []).every(allocation => bundleDiscounts.includes(allocation.discount_application.title))
      );
      const qualifyingTotal = cart.total_price;
      if (cart.currency !== 'USD' || cart.total_price < 4000 || cart.total_price >= 5000 || !discountsAllowed || cart.items.some(item => item.properties?._pat_cart_addon === 'wooden-999')) {
        window.location.assign(root + 'cart');
        return;
      }
      status.textContent = offer.dataset.busyLabel;
      for (const item of cart.items) {
        await request('cart/change.js', { id: item.key, quantity: item.quantity, properties: { ...item.properties, _pat_cart_addon: 'regular' } });
      }
      await request('cart/add.js', { items: [{ id: Number(button.dataset.patWoodenAdd), quantity: 1, properties: { _pat_cart_addon: 'wooden-999' } }] });
      added = true;
      cart = await request('cart.js');
      const selected = cart.items.find(item => item.properties?._pat_cart_addon === 'wooden-999');
      if (!selected || selected.quantity !== 1 || selected.final_line_price !== 999 || cart.total_price !== qualifyingTotal + 999) {
        if (selected) await request('cart/change.js', { id: selected.key, quantity: 0 });
        added = false;
        throw new Error('Offer price unavailable');
      }
      window.location.assign(root + 'cart');
    } catch (error) {
      if (added) {
        window.location.assign(root + 'cart');
        return;
      }
      status.textContent = offer.dataset.error;
      offer.dataset.busy = 'false';
      controls.forEach(control => { control.disabled = false; });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pat-black-friday-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pat-black-friday-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector('dialog');
    const storageKey = `pat-black-friday-popup-${popup.dataset.sectionId}`;
    const designMode = popup.dataset.designMode === 'true';
    const now = new Date();
    const startsAt = new Date(popup.dataset.startsAt);
    const endsAt = new Date(popup.dataset.endsAt);
    const scheduled = now >= startsAt && now < endsAt;

    const rememberDismissal = () => {
      if (designMode) return;
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch {}
    };

    const close = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };

    const open = () => {
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    };

    let dismissed = false;
    try {
      dismissed = window.sessionStorage.getItem(storageKey) === 'dismissed';
    } catch {}

    if ((designMode || scheduled) && !dismissed) {
      window.setTimeout(open, designMode ? 0 : Number(popup.dataset.delay) * 1000);
    }

    popup.querySelectorAll('[data-pat-black-friday-popup-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    popup.querySelectorAll('[data-pat-black-friday-popup-link]').forEach((link) => {
      link.addEventListener('click', rememberDismissal);
    });

    dialog.addEventListener('cancel', rememberDismissal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === popup.dataset.sectionId) open();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pat-bundle-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pat-bundle-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector('dialog');
    const storageKey = `pat-bundle-popup-${popup.dataset.sectionId}`;
    const designMode = popup.dataset.designMode === 'true';
    const now = new Date();
    const pauseStart = new Date(popup.dataset.pauseStart);
    const pauseEnd = new Date(popup.dataset.pauseEnd);
    const blackFridayActive = now >= pauseStart && now < pauseEnd;

    const rememberDismissal = () => {
      if (designMode) return;
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch {}
    };

    const close = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };

    const open = () => {
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    };

    let dismissed = false;
    try {
      dismissed = window.sessionStorage.getItem(storageKey) === 'dismissed';
    } catch {}

    if (!blackFridayActive && (designMode || !dismissed)) {
      window.setTimeout(open, designMode ? 0 : Number(popup.dataset.delay) * 1000);
    }

    popup.querySelectorAll('[data-pat-popup-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    popup.querySelectorAll('[data-pat-popup-link]').forEach((link) => {
      link.addEventListener('click', rememberDismissal);
    });

    dialog.addEventListener('cancel', rememberDismissal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === popup.dataset.sectionId) open();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silly-pat-trio-bundle"] && !Shopify.designMode) return;
  try {
    
  class SillyPatBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.quantities = new Map();
      this.sponge = null;
      this.loading = false;
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.spongeOptions = Array.from(this.querySelectorAll('[data-sponge-option]'));
      this.slots = Array.from(this.querySelectorAll('[data-slot]'));
      this.spongeSlot = this.querySelector('[data-sponge-slot]');
      this.countElement = this.querySelector('[data-selected-count]');
      this.regularValueElement = this.querySelector('[data-regular-value]');
      this.savingsElement = this.querySelector('[data-savings]');
      this.spongeSavingsElement = this.querySelector('[data-sponge-savings]');
      this.shippingElement = this.querySelector('[data-shipping]');
      this.bundlePriceElement = this.querySelector('[data-bundle-price]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-status]');
      this.successElement = this.querySelector('[data-bundle-success]');
      this.fullMessage = this.dataset.fullMessage || 'Your trio is full. Remove a spatula to choose another.';
      this.chooseFreeText = this.dataset.chooseFreeText || 'Choose your free gift';
      this.loadingText = this.dataset.loadingText || 'Adding your happy bundle…';
      this.bundleKey = this.dataset.bundleKey || 'trio';
      this.freeItemRole = this.dataset.freeItemRole || 'sponge';
      this.freeItemClass = this.dataset.freeItemClass || 'sponge';
      this.freeItemType = this.dataset.freeItemType || 'sponge';
      this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      this.addEventListener('click', (event) => this.handleClick(event));
      this.applyDefaults();
      this.update();
    }

    applyDefaults() {
      this.quantities.clear();
      this.cards
        .filter((card) => card.dataset.defaultSelected === 'true')
        .slice(0, 3)
        .forEach((card) => this.quantities.set(card.dataset.variantId, 1));

      const defaultSponge = this.spongeOptions.find((option) => option.dataset.defaultSponge === 'true') || this.spongeOptions[0];
      if (defaultSponge) {
        this.sponge = {
          id: defaultSponge.dataset.variantId,
          price: Number(defaultSponge.dataset.price),
          title: defaultSponge.dataset.title,
          image: defaultSponge.dataset.image
        };
        this.spongeOptions.forEach((option) => option.setAttribute('aria-pressed', String(option === defaultSponge)));
      }
    }

    get selectedCount() {
      return Array.from(this.quantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    handleClick(event) {
      const increase = event.target.closest('[data-increase]');
      const decrease = event.target.closest('[data-decrease]');
      const spongeOption = event.target.closest('[data-sponge-option]');
      const filter = event.target.closest('[data-filter]');

      if (increase) this.changeQuantity(increase.closest('[data-product-card]'), 1);
      if (decrease) this.changeQuantity(decrease.closest('[data-product-card]'), -1);
      if (spongeOption) this.selectSponge(spongeOption);
      if (filter) this.setFilter(filter);
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
      if (event.target.closest('[data-build-another]')) this.buildAnother();
    }

    setFilter(filter) {
      const value = filter.dataset.filter;
      this.filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      this.cards.forEach((card) => {
        card.hidden = value !== 'all' && card.dataset.kind !== value;
      });
    }

    changeQuantity(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.quantities.get(variantId) || 0;
      const next = current + change;

      if (next < 0) return;
      if (change > 0 && this.selectedCount >= 3) {
        this.setStatus(this.fullMessage);
        return;
      }

      if (next === 0) this.quantities.delete(variantId);
      else this.quantities.set(variantId, next);
      this.setStatus('');
      this.update();
    }

    selectSponge(option) {
      this.sponge = {
        id: option.dataset.variantId,
        price: Number(option.dataset.price),
        title: option.dataset.title,
        image: option.dataset.image
      };
      this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      this.setStatus('');
      this.update();
    }

    selectedItems() {
      const selected = [];
      this.cards.forEach((card) => {
        const quantity = this.quantities.get(card.dataset.variantId) || 0;
        if (!quantity) return;
        selected.push({
          id: Number(card.dataset.variantId),
          quantity,
          price: Number(card.dataset.price),
          kind: card.dataset.kind,
          discountRate: Number(card.dataset.discountRate),
          sku: card.dataset.sku,
          title: card.dataset.title,
          image: card.dataset.image
        });
      });
      return selected;
    }

    update() {
      const totalSelected = this.selectedCount;
      const selected = this.selectedItems();
      if (this.countElement) this.countElement.textContent = String(totalSelected);

      this.cards.forEach((card) => {
        const quantity = this.quantities.get(card.dataset.variantId) || 0;
        card.dataset.selected = String(quantity > 0);
        const quantityElement = card.querySelector('[data-quantity]');
        const increase = card.querySelector('[data-increase]');
        const decrease = card.querySelector('[data-decrease]');
        if (quantityElement) quantityElement.textContent = String(quantity);
        if (increase) increase.disabled = totalSelected >= 3;
        if (decrease) decrease.disabled = quantity === 0;
      });

      const selectedImages = [];
      selected.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) selectedImages.push(item);
      });
      this.slots.forEach((slot, index) => {
        const item = selectedImages[index];
        slot.replaceChildren();
        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          slot.appendChild(image);
        } else {
          const label = document.createElement('span');
          label.textContent = String(index + 1);
          slot.appendChild(label);
        }
      });

      if (this.spongeSlot) {
        this.spongeSlot.replaceChildren();
        if (this.sponge?.image) {
          const image = document.createElement('img');
          image.src = this.sponge.image;
          image.alt = this.sponge.title;
          this.spongeSlot.appendChild(image);
        } else {
          const label = document.createElement('span');
          label.textContent = '+';
          this.spongeSlot.appendChild(label);
        }
      }

      const fullProductValue = selected.reduce((total, item) => total + item.price * item.quantity, 0);
      const productSavings = selected.reduce((total, item) => {
        const discount = Math.floor(item.price * (item.discountRate / 100));
        return total + discount * item.quantity;
      }, 0);
      const regularValue = fullProductValue + (this.sponge ? this.sponge.price : 0);
      const bundlePrice = fullProductValue - productSavings;
      const savings = productSavings + (this.sponge ? this.sponge.price : 0);

      this.regularValueElement.textContent = totalSelected === 3 && this.sponge ? this.formatMoney(regularValue) : '—';
      this.savingsElement.textContent = totalSelected === 3 && this.sponge ? `(-${this.formatMoney(savings)})` : '—';
      if (this.spongeSavingsElement) {
        this.spongeSavingsElement.textContent = totalSelected === 3 && this.sponge ? `(-${this.formatMoney(this.sponge.price)})` : '—';
      }
      this.bundlePriceElement.textContent = totalSelected === 3 ? this.formatMoney(bundlePrice) : '—';
      if (this.shippingElement) {
        if (totalSelected !== 3) this.shippingElement.textContent = '—';
        else if (bundlePrice >= 5000) this.shippingElement.textContent = 'FREE';
        else this.shippingElement.textContent = `${this.formatMoney(5000 - bundlePrice)} away`;
      }

      const ready = totalSelected === 3 && Boolean(this.sponge);
      this.addButton.disabled = !ready || this.loading;
      if (this.loading) this.addButton.textContent = this.loadingText;
      else if (ready) this.addButton.textContent = `Add bundle — ${this.formatMoney(bundlePrice)}`;
      else if (totalSelected < 3) this.addButton.textContent = `Choose ${3 - totalSelected} more spatula${3 - totalSelected === 1 ? '' : 's'}`;
      else this.addButton.textContent = this.chooseFreeText;
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message;
    }

    async refreshCartUi(root) {
      if (typeof window.updateCart === 'function') {
        window.updateCart();
        return;
      }

      if (document.getElementById('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('update-cart'));
        document.dispatchEvent(new CustomEvent('pat:drawer-cart-updated'));
        return;
      }

      const cart = await fetch(`${root}cart.js`, {
        cache: 'no-store',
        credentials: 'same-origin'
      }).then((response) => response.json());
      const count = Number(cart.item_count || 0);
      const badge = document.querySelector('.cart-icon-count');
      if (badge) {
        badge.textContent = String(count);
        badge.parentElement?.classList.toggle('hidden', count === 0);
      }
      const cartShell = document.getElementById('cart');
      if (cartShell) cartShell.dataset.quantity = String(count);
    }

    buildAnother() {
      if (this.successElement) this.successElement.hidden = true;
      this.applyDefaults();
      this.setStatus('');
      this.update();
      this.querySelector('[data-product-card]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async addBundle() {
      if (this.loading || this.selectedCount !== 3 || !this.sponge) return;
      this.loading = true;
      if (this.successElement) this.successElement.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const bundleId = globalThis.crypto?.randomUUID?.() || `pat-${this.bundleKey}-${Date.now()}`;
        const items = this.selectedItems().map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: this.bundleKey,
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'pat',
            _pat_bundle_class: item.kind,
            _pat_bundle_item: item.kind === 'clementine' ? 'pat-clementine' : 'pat-standard'
          }
        }));
        items.push({
          id: Number(this.sponge.id),
          quantity: 1,
          properties: {
            _pat_bundle: this.bundleKey,
            _pat_bundle_id: bundleId,
            _pat_bundle_role: this.freeItemRole,
            _pat_bundle_class: this.freeItemClass,
            _pat_bundle_item: this.freeItemType
          }
        });

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add the bundle to your cart.');
        await this.refreshCartUi(root);
        this.loading = false;
        this.quantities.clear();
        this.sponge = null;
        this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setStatus('');
        this.update();
        if (this.successElement) {
          this.successElement.hidden = false;
          this.successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || 'Something went wrong. Please try again.');
        this.update();
      }
    }
  }

  if (!customElements.get('silly-pat-bundle')) {
    customElements.define('silly-pat-bundle', SillyPatBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sudsy-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class SudsyBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.attachPageShowHandler();
        return;
      }
      this.initialized = true;
      this.tier = 1;
      this.bundleQuantity = 1;
      this.counts = { clementine: 0, flamingo: 0 };
      this.freeColor = null;
      this.loading = false;
      this.tierButtons = Array.from(this.querySelectorAll('[data-tier]'));
      this.colorCards = Array.from(this.querySelectorAll('[data-color-card]'));
      this.freeButtons = Array.from(this.querySelectorAll('[data-free-color]'));
      this.variants = Array.from(this.querySelectorAll('[data-bundle-variant]'));
      this.slots = this.querySelector('[data-slots]');
      this.selectedCount = this.querySelector('[data-selected-count]');
      this.requiredCount = this.querySelector('[data-required-count]');
      this.regularValue = this.querySelector('[data-regular-value]');
      this.savings = this.querySelector('[data-savings]');
      this.bundlePrice = this.querySelector('[data-bundle-price]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.bundleQuantityElement = this.querySelector('[data-bundle-quantity]');
      this.bundleDecrease = this.querySelector('[data-bundle-decrease]');
      this.bundleIncrease = this.querySelector('[data-bundle-increase]');
      this.status = this.querySelector('[data-status]');
      this.freeStep = this.querySelector('[data-free-step]');
      this.success = this.querySelector('[data-success]');
      this.galleryViewport = this.querySelector('[data-gallery-viewport]');
      this.gallerySlides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.galleryDots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.galleryPrevious = this.querySelector('[data-gallery-prev]');
      this.galleryNext = this.querySelector('[data-gallery-next]');
      this.galleryIndex = 0;
      this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      this.pageShowHandler = (event) => this.handlePageShow(event);
      this.addEventListener('click', (event) => this.handleClick(event));
      this.attachPageShowHandler();
      if (this.galleryViewport) {
        this.galleryViewport.addEventListener('scroll', () => this.queueGalleryUpdate(), { passive: true });
        this.galleryViewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setGallery(this.galleryIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.setGallery(this.galleryIndex + 1);
          }
        });
      }
      this.updateTierPrices();
      this.updateGallery(0);
      this.update();
    }

    disconnectedCallback() {
      if (this.pageShowHandler) window.removeEventListener('pageshow', this.pageShowHandler);
    }

    attachPageShowHandler() {
      if (!this.pageShowHandler) return;
      window.removeEventListener('pageshow', this.pageShowHandler);
      window.addEventListener('pageshow', this.pageShowHandler);
    }

    handlePageShow(event) {
      const navigation = performance.getEntriesByType('navigation')[0];
      if (!event.persisted && navigation?.type !== 'back_forward') return;
      this.loading = false;
      this.reset(false);
    }

    get selectedTotal() {
      return this.counts.clementine + this.counts.flamingo;
    }

    handleClick(event) {
      const tierButton = event.target.closest('[data-tier]');
      const increase = event.target.closest('[data-increase]');
      const decrease = event.target.closest('[data-decrease]');
      const freeButton = event.target.closest('[data-free-color]');
      const bundleDecrease = event.target.closest('[data-bundle-decrease]');
      const bundleIncrease = event.target.closest('[data-bundle-increase]');
      const galleryPrevious = event.target.closest('[data-gallery-prev]');
      const galleryNext = event.target.closest('[data-gallery-next]');
      const galleryDot = event.target.closest('[data-gallery-dot]');
      if (tierButton) this.setTier(Number(tierButton.dataset.tier));
      if (increase) this.changeColor(increase.closest('[data-color-card]'), 1);
      if (decrease) this.changeColor(decrease.closest('[data-color-card]'), -1);
      if (freeButton) this.setFreeColor(freeButton.dataset.freeColor);
      if (bundleDecrease) this.changeBundleQuantity(-1);
      if (bundleIncrease) this.changeBundleQuantity(1);
      if (galleryPrevious) this.setGallery(this.galleryIndex - 1);
      if (galleryNext) this.setGallery(this.galleryIndex + 1);
      if (galleryDot) this.setGallery(Number(galleryDot.dataset.galleryDot));
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
      if (event.target.closest('[data-build-another]')) this.reset();
    }

    setGallery(index) {
      if (!this.galleryViewport || this.gallerySlides.length === 0) return;
      const nextIndex = Math.max(0, Math.min(index, this.gallerySlides.length - 1));
      const slide = this.gallerySlides[nextIndex];
      this.galleryViewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.updateGallery(nextIndex);
    }

    queueGalleryUpdate() {
      if (this.galleryFrame) cancelAnimationFrame(this.galleryFrame);
      this.galleryFrame = requestAnimationFrame(() => {
        const left = this.galleryViewport.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        this.gallerySlides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        this.updateGallery(closestIndex);
      });
    }

    updateGallery(index) {
      this.galleryIndex = index;
      this.galleryDots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.galleryPrevious) this.galleryPrevious.disabled = index === 0;
      if (this.galleryNext) this.galleryNext.disabled = index === this.gallerySlides.length - 1;
    }

    setTier(tier) {
      if (this.success) this.success.hidden = true;
      this.setStatus('');
      if (this.tier === tier) {
        this.update();
        return;
      }
      this.tier = tier;
      this.counts = { clementine: 0, flamingo: 0 };
      this.freeColor = null;
      this.update();
    }

    changeColor(card, change) {
      if (!card) return;
      if (this.success) this.success.hidden = true;
      const color = card.dataset.colorCard;
      const next = this.counts[color] + change;
      if (next < 0) return;
      if (change > 0 && this.selectedTotal >= this.tier) {
        this.setStatus(this.dataset.errorLabel);
        return;
      }
      this.counts[color] = next;
      this.setStatus('');
      this.update();
    }

    setFreeColor(color) {
      if (this.tier !== 6) return;
      if (this.success) this.success.hidden = true;
      this.freeColor = color;
      this.setStatus('');
      this.update();
    }

    changeBundleQuantity(change) {
      const next = this.bundleQuantity + change;
      if (next < 1 || next > 3) return;
      if (this.success) this.success.hidden = true;
      this.bundleQuantity = next;
      this.update();
    }

    updateTierPrices() {
      [1, 3, 6].forEach((tier) => {
        const variant = this.variants.find((item) => item.dataset.tier === this.tierName(tier));
        const price = this.querySelector(`[data-tier-price="${tier}"]`);
        if (!variant || !price) return;
        if (tier === 3) price.textContent = `${this.formatMoney(Math.round(Number(variant.dataset.price) / 3))} / each`;
        else if (tier === 6) price.textContent = `${this.formatMoney(Math.round(Number(variant.dataset.price) / 7))} / each`;
        else price.textContent = this.formatMoney(Number(variant.dataset.price));
      });
    }

    tierName(tier = this.tier) {
      if (tier === 1) return this.dataset.tierOne;
      if (tier === 3) return this.dataset.tierThree;
      return this.dataset.tierSix;
    }

    mixName() {
      return `${this.counts.clementine}C/${this.counts.flamingo}F`;
    }

    freeName() {
      if (this.tier !== 6) return this.dataset.freeNone;
      if (this.freeColor === 'clementine') return this.dataset.freeClementine;
      if (this.freeColor === 'flamingo') return this.dataset.freeFlamingo;
      return '';
    }

    matchingVariant() {
      const freeName = this.freeName();
      if (!freeName) return null;
      return this.variants.find((variant) => {
        return variant.dataset.tier === this.tierName() && variant.dataset.mix === this.mixName() && variant.dataset.free === freeName;
      }) || null;
    }

    update() {
      this.tierButtons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.tier) === this.tier)));
      this.colorCards.forEach((card) => {
        const color = card.dataset.colorCard;
        const quantity = this.counts[color];
        card.dataset.selected = String(quantity > 0);
        card.querySelector('[data-quantity]').textContent = String(quantity);
        card.querySelector('[data-decrease]').disabled = quantity === 0;
        card.querySelector('[data-increase]').disabled = this.selectedTotal >= this.tier;
      });
      this.freeButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.freeColor === this.freeColor)));
      this.freeStep.hidden = this.tier !== 6;
      this.bundleQuantityElement.textContent = String(this.bundleQuantity);
      this.bundleDecrease.disabled = this.bundleQuantity === 1;
      this.bundleIncrease.disabled = this.bundleQuantity === 3;
      this.selectedCount.textContent = String(this.selectedTotal);
      this.requiredCount.textContent = String(this.tier);
      this.renderSlots();

      const variant = this.matchingVariant();
      const selectionComplete = this.selectedTotal === this.tier && (this.tier !== 6 || Boolean(this.freeColor));
      const unitPrice = variant ? Number(variant.dataset.price) : 0;
      const regularUnitPrice = this.regularPrice();
      const price = unitPrice * this.bundleQuantity;
      const regular = regularUnitPrice * this.bundleQuantity;
      const savings = Math.max(regular - price, 0);
      this.regularValue.textContent = selectionComplete && variant ? this.formatMoney(regular) : '—';
      this.savings.textContent = selectionComplete && variant ? this.formatMoney(savings) : '—';
      this.bundlePrice.textContent = selectionComplete && variant ? this.formatMoney(price) : '—';
      this.addButton.disabled = !selectionComplete || !variant || variant.dataset.available !== 'true' || this.loading;

      if (this.loading) this.addButton.textContent = this.dataset.addingLabel;
      else if (selectionComplete && variant && variant.dataset.available !== 'true') this.addButton.textContent = this.dataset.soldOutLabel;
      else if (selectionComplete && variant) {
        const addLabel = this.bundleQuantity === 1
          ? this.dataset.addLabel
          : this.dataset.addMultipleLabel.replace('[count]', String(this.bundleQuantity));
        this.addButton.textContent = `${addLabel} — ${this.formatMoney(price)}`;
      }
      else if (this.selectedTotal < this.tier) this.addButton.textContent = this.dataset.chooseLabel.replace('[count]', String(this.tier - this.selectedTotal));
      else this.addButton.textContent = this.dataset.chooseFreeLabel;
    }

    regularPrice() {
      const clementine = this.colorCards.find((card) => card.dataset.colorCard === 'clementine');
      const flamingo = this.colorCards.find((card) => card.dataset.colorCard === 'flamingo');
      let total = this.counts.clementine * Number(clementine?.dataset.price || 0);
      total += this.counts.flamingo * Number(flamingo?.dataset.price || 0);
      if (this.tier === 6 && this.freeColor === 'clementine') total += Number(clementine?.dataset.price || 0);
      if (this.tier === 6 && this.freeColor === 'flamingo') total += Number(flamingo?.dataset.price || 0);
      return total;
    }

    renderSlots() {
      this.slots.replaceChildren();
      const items = [];
      this.colorCards.forEach((card) => {
        const quantity = this.counts[card.dataset.colorCard];
        for (let index = 0; index < quantity; index += 1) {
          items.push({ image: card.dataset.image, title: card.dataset.title, free: false });
        }
      });
      if (this.tier === 6) {
        const freeCard = this.colorCards.find((card) => card.dataset.colorCard === this.freeColor);
        if (freeCard) items.push({ image: freeCard.dataset.image, title: freeCard.dataset.title, free: true });
      }
      const totalSlots = this.tier === 6 ? 7 : this.tier;
      for (let index = 0; index < totalSlots; index += 1) {
        const slot = document.createElement('div');
        slot.className = 'sudsy-builder__slot';
        const item = items[index];
        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          slot.appendChild(image);
          if (item.free) {
            slot.classList.add('sudsy-builder__slot--free');
            slot.dataset.freeBadge = this.querySelector('[data-free-color] strong')?.textContent || '';
          }
        } else {
          const label = document.createElement('span');
          label.textContent = String(index + 1);
          slot.appendChild(label);
        }
        this.slots.appendChild(slot);
      }
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      this.status.textContent = message;
    }

    async refreshCartUi(root) {
      if (typeof window.updateCart === 'function') {
        window.updateCart();
        return;
      }

      if (document.getElementById('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('update-cart'));
        document.dispatchEvent(new CustomEvent('pat:drawer-cart-updated'));
        return;
      }

      const cart = await fetch(`${root}cart.js`, {
        cache: 'no-store',
        credentials: 'same-origin'
      }).then((response) => response.json());
      const count = Number(cart.item_count || 0);
      const badge = document.querySelector('.cart-icon-count');
      if (badge) {
        badge.textContent = String(count);
        badge.parentElement?.classList.toggle('hidden', count === 0);
      }
      const cartShell = document.getElementById('cart');
      if (cartShell) cartShell.dataset.quantity = String(count);
    }

    reset(scroll = true) {
      this.counts = { clementine: 0, flamingo: 0 };
      this.freeColor = null;
      this.bundleQuantity = 1;
      this.success.hidden = true;
      this.setStatus('');
      this.update();
      if (scroll) this.querySelector('[data-tier]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async addBundle() {
      const variant = this.matchingVariant();
      if (this.loading || !variant || variant.dataset.available !== 'true') return;
      this.loading = true;
      this.success.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variant.dataset.id),
              quantity: this.bundleQuantity,
              properties: {
                _pat_bundle: 'sudsy',
                _pat_bundle_tier: this.tierName(),
                _pat_bundle_mix: this.mixName(),
                _pat_bundle_free_color: this.freeName()
              }
            }]
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.errorLabel);
        await this.refreshCartUi(root);
        this.loading = false;
        this.counts = { clementine: 0, flamingo: 0 };
        this.freeColor = null;
        this.setStatus('');
        this.update();
        this.success.hidden = false;
        this.success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || this.dataset.errorLabel);
        this.update();
      }
    }
  }

  if (!customElements.get('sudsy-bundle-builder')) {
    customElements.define('sudsy-bundle-builder', SudsyBundleBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
